function toMessageString(message: string | string[] | null | undefined): string {
    if (message == null) {
        return '';
    }

    return Array.isArray(message) ? message.join('\n') : message;
}

// ----------------------------------------------------------------------------

export default toMessageString;
